<div
  class="fixed inset-0 z-9999 flex flex-col justify-center items-center transition-opacity duration-500 select-none"
  [class.bg-negro]="loadingService.fondoOscuro()"
  [class.bg-gris]="!loadingService.fondoOscuro()"
  [class.opacity-100]="loadingService.isLoading()"
  [class.opacity-0]="!loadingService.isLoading()"
  [class.pointer-events-none]="loadingService.isFullyLoaded()"
  *ngIf="!loadingService.isFullyLoaded()"
>

  <div class="flex items-center justify-center mb-12">
    <img
      src="https://deportivo-municipal.s3.us-east-2.amazonaws.com/assets/logo-loading.png"
      alt="Municipal Logo"
      class="w-55 sm:w-70 md:w-[320px] h-auto object-contain transition-opacity duration-500"
      [class.opacity-50]="!loadingService.isProgressComplete()"
      [class.opacity-100]="loadingService.isProgressComplete()"
    />
  </div>

  <div
    class="w-[85vw] max-w-135 h-1.5 bg-gris-linea rounded-full overflow-hidden transition-opacity duration-300"
    [class.opacity-100]="!loadingService.isProgressComplete()"
    [class.opacity-0]="loadingService.isProgressComplete()"
  >
    <div class="loader-bar h-full bg-[#FF0808]"></div>
  </div>

</div>
